<template>
  <div v-if="prompt.type === 'text'">
    <payload-text
      :index="index"
      :prompt="prompt"
      @deletePrompt="deletePrompt"
    />
  </div>
  <div v-else-if="prompt.type === 'tts'">
    <payload-tts
      :index="index"
      :prompt="prompt"
      :items="ttsChoices"
      :ttsProperty="ttsProperty"
      :isMainPlaying="isMainPlaying"
      @isSubPlaying="isSubPlaying"
      @deletePrompt="deletePrompt"
    />
  </div>
  <div v-else-if="prompt.type === 'file'">
    <payload-file
      :minioHost="minioHost"
      :index="index"
      :prompt="prompt"
      :items="voicePaths"
      @deletePrompt="deletePrompt"
    />
  </div>
  <div v-else-if="prompt.type === 'image'">
    <payload-image-url
      :index="index"
      :prompt="prompt"
      :items="imagePaths"
      @deletePrompt="deletePrompt"
    />
  </div>
  <div v-else-if="prompt.type === 'video'">
    <payload-video-url
      :index="index"
      :prompt="prompt"
      :items="videoPaths"
      @deletePrompt="deletePrompt"
    />
  </div>
  <div v-else-if="prompt.type === 'button'">
    <payload-button
      :index="index"
      :prompt="prompt"
      @deletePrompt="deletePrompt"
    />
  </div>
  <div v-else-if="prompt.type === 'quick_reply'">
    <payload-quick-reply
      :index="index"
      :prompt="prompt"
      @deletePrompt="deletePrompt"
    />
  </div>
  <div v-else-if="prompt.type === 'carousel'">
    <payload-carousel
      :index="index"
      :prompt="prompt"
      :items="imagePaths"
      @deletePrompt="deletePrompt"
    />
  </div>
  <div v-else-if="prompt.type === 'parameter'">
    <payload-parameter
      :index="index"
      :prompt="prompt"
      @deletePrompt="deletePrompt"
    />
  </div>
  <div v-else-if="prompt.type === 'pause'">
    <payload-pause
      :index="index"
      :prompt="prompt"
      @deletePrompt="deletePrompt"
    />
  </div>
</template>

<script>
import PayloadText from './text'
import PayloadTts from './tts'
import PayloadFile from './file'
import PayloadImageUrl from './image'
import PayloadVideoUrl from './video'
import PayloadButton from './button'
import PayloadQuickReply from './quick-reply'
import PayloadCarousel from './carousel'
import PayloadParameter from './parameter'
import PayloadPause from './pause'

export default {
  components: {
    PayloadText,
    PayloadTts,
    PayloadFile,
    PayloadImageUrl,
    PayloadVideoUrl,
    PayloadButton,
    PayloadQuickReply,
    PayloadCarousel,
    PayloadParameter,
    PayloadPause
  },
  props: {
    index: Number,
    prompt: Object,
    imagePaths: Array,
    videoPaths: Array,
    voicePaths: Array,
    ttsChoices: Array,
    ttsProperty: Object,
    isMainPlaying: Boolean
  },
  methods: {
    isSubPlaying() {
      this.$emit('isSubPlaying', null)
    },
    deletePrompt(index) {
      this.$emit('deletePrompt', index)
    }
  }
}
</script>
